<template>
	<div class="login" ref="index_content">
		<div v-if="stateMessageIndex.data&&stateMessageIndex.data.length>0" class="swiper-content">
		    <el-carousel :interval="4000" indicator-position="none" arrow="never" direction="vertical" height="150px">
		      <el-carousel-item v-for="(item,index) in stateMessageIndex.data" :key="index">
		        <div @click="toMessage" class="swiper-items">
					<img class="item-img" src="~@/assets/image/u200.png" alt="">
					<div class="item_text">
						<span v-if="item.mtype==1" style="color: #1E9FFF;">【平台公告】</span>
						<span v-if="item.mtype==2" style="color: #1E9FFF;">【审核通知】</span>
						<span>{{item.title}}：{{item.desc}}</span>
					  
					</div>
				</div>
		      </el-carousel-item>
		    </el-carousel>
		  </div>
		<div class="index_content" v-if="count">
			<div class="show-pane">
				<div class="show-pane-title">
				<svg class="index_icon"><use xlink:href="#icon-shouru"></use></svg>累计总收益</div>
				<div class="show-pane-num">{{count.author_info.total_income}}</div>
				<div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div>
				<div class="show-pane-bot">可提现余额 {{count.author_info.surplus}}</div>
			</div>
			<div class="show-pane">
				<div class="show-pane-title"><svg class="index_icon"><use xlink:href="#icon-a-shouru1"></use></svg>今日收入</div>
				<div class="show-pane-num">{{count.order_sum.today}}</div>
				<div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div>
				<div class="show-pane-bot">昨日收入 {{count.order_sum.yestoday}}<i class="iconfont" style="font-size: 12px" :class="{'incon_up': count.order_sum.today*100 > count.order_sum.yestoday*100}">&#xe834;</i></div>
			</div>
			<div class="show-pane">
				<div class="show-pane-title"><svg class="index_icon"><use xlink:href="#icon-dingdan"></use></svg>今日订单</div>
				<div class="show-pane-num"> {{count.order_count.today}}</div>
				<div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div>
				<div class="show-pane-bot">昨日订单数 {{count.order_count.yestoday}} <i class="iconfont" style="font-size: 12px" :class="{'incon_up': count.order_count.today >count.order_count.yestoday}">&#xe834;</i></div>
			</div>
			<div v-if="showTodayEvaluate" class="show-pane">
				<div class="show-pane-title"><svg class="index_icon"><use xlink:href="#icon-pingjiabeifen"></use></svg>今日评价</div>
				<div class="show-pane-num">{{count.comm.today}}</div>
				<div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div>
				<div class="show-pane-bot">昨日评价数 {{count.comm.yestoday}}<i class="iconfont" style="font-size: 12px" :class="{'incon_up': count.comm.today >count.comm.yestoday}">&#xe834;</i></div>
			</div>
		</div>
		<div style="z-index: 99999;height: 20px">
		</div>
		<div class="mian_wrap">
			<el-radio-group v-model="day" class="index_radio_gr" size="small" @change="changeDay">
				<el-radio-button label="7">7天</el-radio-button>
				<el-radio-button label="15">15天</el-radio-button>
				<el-radio-button label="30">30天</el-radio-button>
			</el-radio-group>
			<div style="width: 100%;height: 100%" id="main"></div>	
		</div>
		<!-- <div class="active_mask" v-show="activeFlag">
			<div class="active_mask_con">
				<el-scrollbar style="height: 100%;">
					<div class="active_mask_con_img">
						<img :src="activeImg" alt=""/>
						<span class="el-icon-circle-close close_active" @click="closeMask"></span>
					</div>
				</el-scrollbar>
			</div>
		</div> -->
		<el-dialog
		  title="公告"
		  :visible.sync="centerDialogVisible"
		  v-if="centerDialogVisible"
		  width="30%"
		  center
		  >
		  <p>
			 <span v-if="swiperData[0]&&swiperData[0].mtype==1">【平台公告】</span>
			  <span v-if="swiperData[0]&&swiperData[0].mtype==2">【审核通知】</span> 
			  <span>{{swiperData[0].title}}</span>
		  </p>
		  <span>{{swiperData[0].desc}}</span>
			<span @click="tiDetail(swiperData[0])" style="color:#1E9FFF;cursor:pointer;">点击查看详情</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
		<!-- <author-supplement v-model="authorization"></author-supplement> -->
	</div>
</template>
<script>
	import { mapMutations, mapState,mapActions } from 'vuex'
	// import authorSupplement from '../../components/authorSupplement/index.vue'
	export default {
		name: 'Login',
		data() {
			return {
				count:null,
				day:30,
				activeImg: '',
				activeFlag: localStorage.getItem('activeFlag')? localStorage.getItem('activeFlag') * 1 :  0,
				centerDialogVisible:false,
				swiperData:[],
				msgKey:false,
				authorization:false
			}
		},
		components:{
			// authorSupplement
		},
		created() {
			this.$watch('centerDialogVisible',(news)=> {
				console.log(news, 'centerDialogVisible')
				if(!news) {
					this.closeMessageDialog()
				}
			})
			this.$nextTick(() => {
				this.$refs['index_content'].parentNode.classList.add('content_index')
			})
			// if(this.staticPath === '/' && this.activeFlag) {
			// 	this.getActiveData()
			// }
			// if(!localStorage.getItem('msgKey')){
			// 	localStorage.setItem('msgKey','1')
			// 	this.msgKey=true
			// }
		},
		
		beforeRouteLeave(to,form,next) {
			this.$refs['index_content'].parentNode.classList.remove('content_index')
			next()
		},
		beforeDestroy() {
			this.closeMessageDialog()
		},
		async mounted(){
			this.checkAuthorization()
			this.draw()
			this.createMessage()
		},
		computed:{
			...mapState('message', ['stateMessageIndex']),
			showTodayEvaluate(){ // 是否渲染今日评价 返回true渲染
				const hideList = ['/sph/', '/xhs/','/dd/'] // 不展示的列表
				if(hideList.includes(this.staticPath)){
					return false
				}else{
					return true
				}
			}
		},
		methods: {
			...mapActions('login', ['counts', 'plateformActive']),
			...mapActions('message', ['messageIndex', 'confirmmessage']),
			...mapActions('help',["quaCheck_authorization"]),
			tiDetail(ite) {
				this.$router.push({
					path:  this.staticPath + "detailMessage",
					query:{
						id:ite.id
					}
				})
			},
			async createMessage(){
				let obj={
					page:1,
					page_size:3
				}
				let res= await this.messageIndex(obj)
				if(res.data.length && !localStorage.getItem('msgKey')) {
					this.centerDialogVisible = !!res.data[0].popup_status
				}
				this.swiperData=res.data
			
			},
			changeDay(day){
				this.day = day
				this.draw()
			},
			toMessage() {
				this.$router.push({
					path:  this.staticPath + "message"
				})
			},
			// async getActiveData() {
			// 	let res = await this.plateformActive({souce: 1})
			// 	this.activeImg = res.active_desc_pic
			// },
			closeMask() {
				localStorage.setItem('activeFlag', 0)
				this.activeFlag = 0
			},
			async draw(){
				this.count = await this.counts({day:this.day})
				let dataList = []  
				let counts = []
				let sums = []
				for(let obj of this.count.list){
					dataList.push(obj.create_date)
					counts.push(obj.counts)
					sums.push(obj.sums)
				}
				let option = {
				    title: {
				        text: ''
				    },
				    tooltip: {
						trigger: 'axis'
					},
					legend: {
				        data: ['订单金额', '订单数量']
				    },
				    grid: {
				        left: '4%',
				        right: '4%',
				        bottom: '4%',
				        // containLabel: true
				    },
				    toolbox: {
				        feature: {
				            saveAsImage: {}
				        }
				    },
				    xAxis: {
				        type: 'category',
				        boundaryGap: false,
				        data: dataList
				    },
				    yAxis: {
				        type: 'value'
				    },
				    series: [
				        {
				            name: '订单金额',
				            type: 'line',
				            // stack: '总量',
				            data: sums,
							itemStyle: {
								color: '#4E70F2'
							}
				        },
				        {
				            name: '订单数量',
				            type: 'line',
				            // stack: '总量',
				            data: counts,
							itemStyle: {
								color: '#FFA360'
							}
				        }
				    ]
				};
				var echarts = require('echarts');
 				console.log(echarts)
				// 基于准备好的dom，初始化echarts实例
				var myChart = echarts.init(document.getElementById('main'));
				console.log(myChart)
				// 绘制图表
				myChart.setOption(option);
			},
			async closeMessageDialog() {
				await this.confirmmessage({message_id:this.swiperData[0].id})
				localStorage.setItem('msgKey', 1)
			},
			async checkAuthorization(){
				let res = await this.quaCheck_authorization()
				if(!localStorage.getItem('authorizeKey')){
					this.authorization = !res.is_authorization
				}
				this.authorization = !res.is_authorization
				console.log(res,'checkAuthorization---')
			}
		}
	}
</script>
<style lang="less">
	.content_index {
		background-color: transparent!important;
		box-shadow: none!important;
		border-radius: 0!important;
		padding:0!important;
	}
</style>
<style lang="less" scoped>
	.index_content{
		height: 150px;
		display: flex;
		justify-content: space-between;
		gap: 20px;
  		div{
  			div{
  				margin: auto;
  			}
  		}
	}
	.show-pane{
		height: 147px;
		min-width: 220px;
		flex: 1;
		background: #fff;
		border-radius: 5px;
		padding: 0 0 0 20px;
		&:hover {
			box-shadow: 2px 2px 10px #ccc;
		}
		&:nth-child(1) {
			border-top: 3px solid #4E70F3;
		}
		&:nth-child(2) {
			border-top: 3px solid #FFA360;
		}
		&:nth-child(3) {
			border-top: 3px solid #67D0AF;
		}
		&:nth-child(4) {
			border-top: 3px solid #40AEFE;
		}
		.show-pane-title {
			font-size: 14px;
    		color: #888a95;
			font-weight: 600;
    		line-height: 27px;
			display: flex;
			align-items: center;
			margin-top: 17px;
		}
		.show-pane-num {
			font-size: 28px;
			font-weight: 600;
			color: #333;
			margin-top: 10px;
			margin-bottom: 10px;
		}
		.show-pane-bot{
			font-size: 14px;
    		color: #37383c;
			display: flex;
			align-items: center;
			.iconfont {
				color: #32b24b;
				font-weight: 600;
				transform: rotate(180deg);
				transform-origin: 50% 50%;
				&.incon_up {
					transform: rotate(0deg);
				}
			}
		 }
	}
	.ac{
		border: 1px solid #1989FA;
		color:#1989FA;
	}
	.bc{
		border: 1px solid #BFBFBF;
		color:#606266;
	}
	td{
		text-align: center;
		padding: 5px 10px;
	}
	.index_icon {
		width: 18px;
		height: 18px;
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;
		margin-right: 6px;
	}
	.mian_wrap {
		background-color: #fff;
		padding: 20px;
		border-radius: 5px;
		box-sizing: border-box;
		position: relative;
		height: 550px;
		.index_radio_gr {
			position: absolute;
			right: 60px;
			top: 20px;
			z-index: 1000;
		}
	}
	.active_mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		z-index: 1000;
		min-width: 80%;
		.active_mask_con {
			width: 100%;
			.active_mask_con_img {
				display: inline-block;
    			margin: 100px 0 50px 0;
				position: relative;
				left: 45%;
				transform: translateX(-50%);
			}
			.close_active {
				position: absolute;
				right: -100px;
				top: 0;
				color: #fff;
				font-size: 30px;
				cursor: pointer;
			}
		}
	}
	.swiper-content{
		width: 1020px;
		height: 53px;
		background-color: #ffffff;
		margin-bottom: 20px;
		overflow: hidden;
	}
	.swiper-items {
	    width: 1020px;
	    height: 53px;
		line-height: 53px;
	    font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
	    font-weight: 400;
		font-size: 13px;
		color: #333333;
		background-color: #ffffff;
		display: flex;
		align-items: center;
		 .item-img{
			 width: 30px;
			 height: 30px;
			 margin-left: 10px;
			}
			.item_text{
				width: 970px;
				height: 53px;
				text-overflow :ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
				white-space :nowrap; /*让文字不换行*/
				overflow : hidden; /*超出要隐藏*/
				margin-left: 5px;
			}
	}
	
</style>
